import { BooleanField, Datagrid, DateField, List, NumberField, TextField } from "react-admin";

export function UserList() {
  return (
    <List perPage={25} sort={{ field: "created_at", order: "DESC" }} exporter={false}>
      <Datagrid bulkActionButtons={false} rowClick="show">
        <NumberField source="telegram_id" />
        <TextField source="first_name" />
        <TextField source="last_name" />
        <TextField source="username" />
        <TextField source="language_code" />
        <BooleanField source="is_premium" />
        <BooleanField source="is_blocked" />
        <DateField source="created_at" showTime />
      </Datagrid>
    </List>
  );
}
